import { type ReactNode, useState, type FC } from 'react';
import { Popover } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Space, Button } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import styles from './confirm.module.scss';

type Props = {
  title?: string | ReactNode;
  description?: string | ReactNode;
  actions?: Action[];
  children?: string | ReactNode;
} & WithOptionalDataTest;

type Action = {
  label: string | ReactNode;
  type?: Button.Type;
  action?: () => void;
};

export const PopConfirm: FC<Props> = (props) => {
  const { dataTestId, actions, title, description, children } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Popover
      content={
        <Space.$ direction={Space.Direction.Vertical} dataTestId={dataTestId}>
          <div>{description}</div>
          <Space.$ direction={Space.Direction.Horizontal} justify={Space.Justify.End}>
            {actions?.map((action, i) => (
              <Button.$
                size={Button.Size.Small}
                key={i}
                type={action.type ?? Button.Type.Default}
                onClick={() => {
                  action.action?.();
                  setIsOpen(false);
                }}
                dataTestId={`${dataTestId}-action-${i}`}
              >
                {action.label}
              </Button.$>
            ))}
          </Space.$>
        </Space.$>
      }
      title={
        <>
          <ExclamationCircleFilled className={styles.confirm__icon} /> {title}
        </>
      }
      onOpenChange={(status) => {
        setIsOpen(status);
      }}
      trigger="click"
      open={isOpen}
    >
      {children}
    </Popover>
  );
};
